import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/auth/useAuth";

interface Props {
  children: React.ReactElement;
  requireAdmin?: boolean;
  requirePermission?: string;
}

export function ProtectedRoute({
  children,
  requireAdmin,
  requirePermission,
}: Props): React.ReactElement {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Загрузка…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (requireAdmin && !user.is_admin) {
    return <ForbiddenPage />;
  }

  if (requirePermission && !user.is_admin && !user.permissions.includes(requirePermission)) {
    return <ForbiddenPage />;
  }

  return children;
}

function ForbiddenPage(): React.ReactElement {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-2">
      <h1 className="text-2xl font-semibold">403 — Доступ запрещён</h1>
      <p className="text-muted-foreground">Нет прав на просмотр этого раздела.</p>
    </div>
  );
}
